import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@js/modules/translations';

function BlogArticle({
                         article,
                         // isOwner = false,
                         isAdmin = false
                     }) {
    return (
        <article className="card-panel blog-article"
                 itemType="http://schema.org/NewsArticle"
                 itemScope={true}>
            {
                !isAdmin &&
                <h1 className="blog-article-title"
                    itemProp="headline">
                    {article.title}
                </h1>
            }

            <meta itemType="https://schema.org/WebPage"
                  itemScope={true}
                  itemProp="mainEntityOfPage"
                  itemID={window.location.pathname}/>

            <meta itemProp="datePublished"
                  content={article.createdAt}/>
            <meta itemProp="dateModified"
                  content={article.updatedAt}/>

            {
                !isAdmin &&
                <div className="blog-article-info">
                <span className="blog-article-author">
                    {I18n.t('js.blog.common.user')}
                    <a className="blog-article-author-link"
                       href={article.user.link}
                       itemType="https://schema.org/Person"
                       itemScope={true}
                       itemProp="author">
                        <span itemProp="name">
                            {article.user.pseudo}
                        </span>
                    </a>
                </span>

                    <span className="blog-article-info-sep">-</span>

                    <span className="blog-article-info-date">
                        {article.date}
                    </span>

                    {
                        (article.tags.length > 0) &&
                        <span className="blog-article-info-tag">
                            <span className="blog-article-info-sep">
                                {I18n.t('js.blog.article.common.tag_separator')}
                            </span>

                            {
                                article.tags.map((tag) => tag.name)
                                    .join(', ')
                            }
                        </span>
                    }

                    <div className="blog-article-info-comment">
                        <a href="#comments">
                        <span className="material-icons"
                              data-icon="comment"
                              aria-hidden="true"/>
                            <span>
                                {I18n.t('js.blog.common.comment_counts', {count: article.commentsCount})}
                            </span>
                        </a>
                    </div>
                </div>
            }

            <section className="blog-article-content">
                <div className="blog-article-body"
                     itemProp="description"
                     dangerouslySetInnerHTML={{__html: article.body}}/>
            </section>

            {
                article.samplePictureFormatted
                    ?
                    <div itemType="https://schema.org/ImageObject"
                         itemScope={true}
                         itemProp="image">
                        <meta itemProp="url"
                              content={article.samplePictureFormatted.url}/>
                        <meta itemProp="width"
                              content={article.samplePictureFormatted.width}/>
                        <meta itemProp="height"
                              content={article.samplePictureFormatted.height}/>
                    </div>
                    :
                    <div itemType="https://schema.org/ImageObject"
                         itemScope={true}
                         itemProp="image">
                        <meta itemProp="url"
                              content={`${window.settings.assets_url}/logos/full_gradient.png`}/>
                        <meta itemProp="width"
                              content="320"/>
                        <meta itemProp="height"
                              content="320"/>
                    </div>
            }

            <div itemType="https://schema.org/Organization"
                 itemProp="publisher"
                 itemScope={true}>
                <div itemType="https://schema.org/ImageObject"
                     itemProp="logo"
                     itemScope={true}>
                    <meta itemProp="url"
                          content={`${window.settings.assets_url}/logos/full_gradient.png`}/>
                    <meta itemProp="width"
                          content="320"/>
                    <meta itemProp="height"
                          content="320"/>
                </div>
                <meta itemProp="name"
                      content="Locatipic"/>
            </div>
        </article>
    );
}

BlogArticle.propTypes = {
    article: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    // isOwner: PropTypes.bool
};

export default React.memo(BlogArticle);
